import { render, staticRenderFns } from "./MoralClassPoolAdmin.vue?vue&type=template&id=4b290d47&scoped=true"
import script from "./MoralClassPoolAdmin.vue?vue&type=script&lang=js"
export * from "./MoralClassPoolAdmin.vue?vue&type=script&lang=js"
import style0 from "./MoralClassPoolAdmin.vue?vue&type=style&index=0&id=4b290d47&prod&scoped=true&lang=css"
import style1 from "./MoralClassPoolAdmin.vue?vue&type=style&index=1&id=4b290d47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b290d47",
  null
  
)

export default component.exports